import { combineReducers } from 'redux';

import loadBannersError from './loadBannersError';
import bannerError from './bannerError';
import deleteBannerError from './deleteBannerError';
import exchangeBannerError from './exchangeBannerError';

export default combineReducers({
  loadBannersError,
  bannerError,
  deleteBannerError,
  exchangeBannerError,
});
